import { gql } from "apollo-boost";

export default gql`
  mutation createListingAgentMatchConnection(
    $agent_name: String!
    $brokerage: String!
    $brokerage_address: String!
    $contact_id: ID!
    $email: String!
    $fingerprint_or_device_guid: String!
    $has_sold_in_building: Boolean
    $homes_sold_nearby: Int
    $homes_sold_recent: Int
    $homes_sold_similar: Int
    $is_pro: Boolean
    $license_type: String!
    $median_sales_price: String
    $name: String
    $notes: String
    $origin_label: String
    $phone: String
    $photo_url: String
    $property_id: ID!
    $user_id: ID!
    $uuid: String
    $years_experience: Int
  ) {
    create_listing_agent_match_connection(
      input: {
        agent_name: $agent_name
        brokerage: $brokerage
        brokerage_address: $brokerage_address
        contact_id: $contact_id
        email: $email
        fingerprint_or_device_guid: $fingerprint_or_device_guid
        has_sold_in_building: $has_sold_in_building
        homes_sold_nearby: $homes_sold_nearby
        homes_sold_recent: $homes_sold_recent
        homes_sold_similar: $homes_sold_similar
        is_pro: $is_pro
        license_type: $license_type
        median_sales_price: $median_sales_price
        name: $name
        notes: $notes
        origin_label: $origin_label
        phone: $phone
        photo_url: $photo_url
        property_id: $property_id
        user_id: $user_id
        uuid: $uuid
        years_experience: $years_experience
      }
    ) {
      contact_id
    }
  }
`;
